export default __webpack_public_path__ + "static/media/done.1b3a4cce.riv";